import { createPersistedResourceCache } from './resourceCache';

const LISTING_CACHE_TTL_MS = 2 * 60 * 1000;

function createListingCache(namespace) {
    return createPersistedResourceCache({ namespace, ttlMs: LISTING_CACHE_TTL_MS });
}

export default createListingCache;
